import React from 'react';
import { Route, useHistory } from 'react-router';
import { Layout } from './shared';
//import { Home } from './components/Home';
import {
  Login,
  Register,
  Profile,
  Offers,
  PreOnboarding,
  EmpHandbook,
  ForgotPassword,
  PasswordReset,
  ChangePassword,
} from './components/Auth';
import { JobList, JobItem, NewJobList, ApplyPage } from './components/Jobs';
import { useSelector } from 'react-redux';
import axios from 'axios';
export const App = () => {

  return (
    <>
      <Layout>
        <Route exact path='/' component={Login} />
        {/**<Route path='/jobs' component={JobList} />**/}
        <Route path='/job-item/:id/:title' component={JobItem} />
        <Route path='/job-apply' component={ApplyPage} />
        {/**<Route path='/jobs' component={NewJobList} />**/}

        <Route path='/login' component={Login} />
        <Route path='/register' component={Register} />
        <Route path='/forgot-password' component={ForgotPassword} />
        <Route path='/passwordreset' component={PasswordReset } />

        <Route path='/profile' component={Profile} />
        <Route path='/offers' component={Offers} />
        <Route path='/pre-onboarding' component={PreOnboarding} />
        <Route path='/employee-handbook' component={EmpHandbook} />
        <Route path='/settings' component={ChangePassword } />
      </Layout>
    </>
  );
}

export default App;
